module.exports = __webpack_public_path__ + "static/pic07-de2c6fb74540c367019ad328e6a78bc1.jpg";